import axios from 'axios';

/* eslint no-extend-native: ["error", { "exceptions": ["Promise"] }] */
Promise.prototype.min = async function (min=1000) { // eslint-disable-line
  const result = await Promise.all([
    this,
    new Promise(resolve => setTimeout(resolve, min)),
  ]);
  return result[0];
};

const HTTP = axios.create({
  baseURL: '/api',
});

export default HTTP;
